module.exports = __webpack_public_path__ + "2acb60f2/img/dollar-icon.35c9d638.svg";